export const GET_ORDER_ITEMS = 'GET_ORDER_ITEMS';
export const SUCCESS_GET_ORDER_ITEMS = 'SUCCESS_GET_ORDER_ITEMS';
export const FAIL_GET_ORDER_ITEMS = 'FAIL_GET_ORDER_ITEMS';

export const GET_DAY_ORDER_ITEMS = 'GET_DAY_ORDER_ITEMS';
export const SUCCESS_GET_DAY_ORDER_ITEMS = 'SUCCESS_GET_DAY_ORDER_ITEMS';
export const FAIL_GET_DAY_ORDER_ITEMS = 'FAIL_GET_DAY_ORDER_ITEMS';

export const EDIT_ORDER_ITEM = 'EDIT_ORDER_ITEM';

export const VALIDATE_ORDER_ITEM = 'VALIDATE_ORDER_ITEM';
export const SUCCESS_VALIDATE_ORDER_ITEM = 'SUCCESS_VALIDATE_ORDER_ITEM';
export const FAIL_VALIDATE_ORDER_ITEM = 'FAIL_VALIDATE_ORDER_ITEM';

export const CREATE_ORDER_ITEM = 'CREATE_ORDER_ITEM';
export const SUCCESS_CREATE_ORDER_ITEM = 'SUCCESS_CREATE_ORDER_ITEM';
export const FAIL_CREATE_ORDER_ITEM = 'FAIL_CREATE_ORDER_ITEM';

export const INIT_ORDER_ITEM = 'INIT_ORDER_ITEM';
